<div class="create_post_page">
    <div class="create_post_main">Create Post</div>
    <hr>
    <div class="row" style="padding: 0% 3% 3% 3%;">
      <div class="col-md-4">
        <div class="create_post_header">COLLECTION</div>
        <div class="create_post_collection">
          <!-- <div class="create_post_collection_title">Select Collection</div>
          <select class="form-control" (change)="onCollectionChange($event)">
            <option value="General">General</option>
            <option value="Business">Business</option>
          </select> -->
          <div class="create_post_collection_subtext">Choose an account to add this post to</div>
          
          <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Account</mat-label>
            <mat-select [(ngModel)]="selectedAccount">
              <mat-option *ngFor="let account of SocialMediaAccountsData" [value]="account.AccountId"><span>
                <img [src]="getImagePath(account.AccountType)" [alt]="account.AccountType"
                    class="social_icon">
            </span>{{ account.AccountName }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="create_post_collection_title">Social Channels</div>
          <div class="channels">
            <span class="badge" *ngFor="let channel of selectedChannels">
              {{channel}}
            </span>
          </div>
          <div class="create_post_collection_subtext">Select social media channels to post on. For convenience,
            add them from the collection to avoid reselecting each time. </div>
          <!-- <mat-slide-toggle style="    padding: 7px 0px;">Schedule once</mat-slide-toggle>
          <div class="create_post_collection_subtext">Your post will be scheduled once and not repeated.</div> -->
          <!-- <div class="actions" style="padding-bottom: 20px;">
            <button class="btn btn-primary" (click)="addToQueue()">Add to Queue</button>
            <button class="btn btn-secondary" (click)="saveAsDraft()">Save as Draft</button>
          </div> -->
          <!-- Scheduled Date -->
<mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Scheduled Date</mat-label>
    <input matInput [matDatepicker]="picker" [(ngModel)]="scheduledDate">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  
  <!-- Hours Dropdown -->
   <div>
    
  <mat-form-field appearance="outline" class="time" >
    <mat-label>Hour</mat-label>
    <mat-select [(ngModel)]="selectedHour">
      <mat-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</mat-option>
    </mat-select>
  </mat-form-field>
  :
  <!-- Minutes Dropdown -->
  <mat-form-field appearance="outline"  class="time" >
    <mat-label>Minute</mat-label>
    <mat-select [(ngModel)]="selectedMinute">
      <mat-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
  <!-- Submit Button -->
   <div><button class="schedule_button" (click)="onSubmit()">Schedule</button></div>
   </div>
      </div>
      <div class="col-md-4">
        <div class="create_post_header">POST EDITOR</div>
        <div class="create_post_content">
          <div class="create_post_content_selections" style="padding-bottom: 20px;">
            <div class="create_post_content_block_part" (click)="toPost()" [ngStyle]="{
                        'background-color': isPost ? 'var(--primary-color)' : '', 
                        'color': isPost ? 'black' : '' }">Post</div>
            <div class="create_post_content_block_part" (click)="toShortVideo()" [ngStyle]="{
                        'background-color': isShortVideo ? 'var(--primary-color)' : '', 
                        'color': isShortVideo ? 'black' : '' }">Short-form Video</div>
            <div class="create_post_content_block_part" (click)="toStory()" [ngStyle]="{
                        'background-color': isStory ? 'var(--primary-color)' : '', 
                        'color': isStory ? 'black' : '' }">Story</div>
            <div class="create_post_content_block_part" (click)="toThread()"  [ngStyle]="{
                        'background-color': isThread ? 'var(--primary-color)' : '', 
                        'color': isThread ? 'black' : '' }">Thread</div>
            <div class="create_post_content_block_part" (click)="toPoll()" [ngStyle]="{
                        'background-color': isPoll ? 'var(--primary-color)': '', 
                        'color': isPoll ? 'black' : '' }">Poll</div>
          </div>
          <div *ngIf="isPost">
            <div class="create_post_collection_subtext" style="padding-bottom: 20px;">Create a text, link,
              image, video posts and carousels.</div>
            <div class="create_post_collection_title">Caption</div>
            <div class="text_content_editor">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editor" [(ngModel)]="editorContent"></ngx-editor>
            </div>
            <div>
              <div class="add_photo_section">
                <button class="add-photo-button" (click)="fileInput.click()">Add Photos</button>
                <input type="file" #fileInput (change)="onFilesSelected($event)" accept="image/*" multiple
                  style="display: none;" />
                <div *ngIf="photoPreviews.length">
                  <div class="create_post_collection_title" style="padding-top: 10px;">Photo Previews
                  </div>
                  <div *ngFor="let photo of photoPreviews"
                    style="margin-bottom: 15px; display: inline-block; margin-right: 15px;">
                    <img [src]="photo" alt="Selected Photo" style="width: 100px; height: 100px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isShortVideo">
            <div class="create_post_collection_subtext" style="padding-bottom: 20px;">
              Create a Reels, Shorts, TikToks and short-form vertical videos.</div>
            <div class="create_post_collection_title">Caption</div>
            <div class="text_content_editor">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editor" [(ngModel)]="editorContent"></ngx-editor>
            </div>
            <div>
              <div class="video-upload-section">
                <button class="add-video-button" (click)="videoInput.click()">Add Video</button>
                <input type="file" #videoInput (change)="onVideoSelected($event)" accept="video/*" style="display: none;" />
              </div>
              <!-- <app-video-player [ClassDetails]="SelectedClassDetails" (UpdateProgress)="handleProgressUpdate($event)" ></app-video-player> -->
            </div>
          </div>
          <div *ngIf="isStory">
            <div class="create_post_collection_subtext" style="padding-bottom: 20px;">
              Create a story or story carousel for Instagram and Facebook</div>
            <div class="create_post_collection_title">Add Image or Video</div>
            <div>
                <div class="video-upload-section" style="margin-bottom: 10px;">
                    <button class="add-video-button" (click)="videoInput.click()">Add Video</button>
                    <input type="file" #videoInput (change)="onVideoSelected($event)" accept="video/*" style="display: none;" />
                  </div>
              <div class="add_photo_section">
                <button class="add-photo-button"  (click)="fileInput.click()">Add Photos</button>
                <input type="file" #fileInput (change)="onFilesSelected($event)" accept="image/*" multiple
                  style="display: none;" />
  
                <div *ngIf="photoPreviews.length">
                  <div class="create_post_collection_title" style="padding-top: 10px;">Photo Previews
                  </div>
                  <div *ngFor="let photo of photoPreviews"
                    style="margin-bottom: 10px; display: inline-block; margin-right: 10px;">
                    <img [src]="photo" alt="Selected Photo" style="width: 100px; height: 100px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isThread">
            <div class="create_post_collection_subtext" style="padding-bottom: 20px;">
              Create a thread for Twitter & Threads. Skip two lines for new tweets.</div>
            <div class="create_post_collection_title">Thread</div>
            <div class="text_content_editor">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editor" [(ngModel)]="editorContent"></ngx-editor>
            </div>
            <div>
              <div class="add_photo_section">
                <button class="add-photo-button" (click)="fileInput.click()">Add Photos</button>
                <input type="file" #fileInput (change)="onFilesSelected($event)" accept="image/*" multiple
                  style="display: none;" />
  
                <div *ngIf="photoPreviews.length">
                  <div class="create_post_collection_title" style="padding-top: 10px;">Photo Previews
                  </div>
                  <div *ngFor="let photo of photoPreviews"
                    style="margin-bottom: 10px; display: inline-block; margin-right: 10px;">
                    <img [src]="photo" alt="Selected Photo" style="width: 100px; height: 100px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isPoll">
            <div class="create_post_collection_subtext" style="padding-bottom: 20px;">
              Create a poll post for LinkedIn, Twitter & Telegram.</div>
            <div class="create_post_collection_title">Poll</div>
            <div class="text_content_editor">
              <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editor" [(ngModel)]="editorContent"></ngx-editor>
            </div>
            <div class="create_post_choice">Choice 1</div>
<mat-form-field appearance="outline" class="page_form_fields">
  <mat-label>Enter value for choice</mat-label>
  <input matInput [(ngModel)]="choice1">
</mat-form-field>

<div class="create_post_choice">Choice 2</div>
<mat-form-field appearance="outline" class="page_form_fields">
  <mat-label>Enter value for choice</mat-label>
  <input matInput [(ngModel)]="choice2">
</mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="create_post_header">PREVIEW</div>
        <div class="create_post_preview">
          <div *ngIf="!isPreviewEmpty">
            <div class="post-preview" [innerHTML]="getsafevalue(editorContent)">
              <div>{{ editorContent }} </div>
            </div>
            <div *ngIf="choice1 && choice2">
                  <div class="choice_section" style="padding: 0px 25px">
                    <button class="choice_part" style="margin-bottom: 15px;">{{ choice1 }}</button>
                    <button class="choice_part">{{ choice2 }}</button>
                  </div>
              </div>            
            <div *ngIf="videoPreview">
              <iframe [src]="sanitizer.bypassSecurityTrustResourceUrl(videoPreview)" width="100%" height="400"  frameborder="0" allowfullscreen></iframe>
              <!-- <iframe [src]="sanitizer.bypassSecurityTrustResourceUrl(videoPreview + '?autoplay=0')"  width="100%" height="400"  frameborder="0" allowfullscreen></iframe> -->
            </div>
            <div *ngIf="photoPreviews.length" class="slider-container" style="margin: 10px 0px 20px 0px;">
              <div class="slider" [style.transform]="'translateX(' + (-currentIndex * 100) + '%)'">
                <div *ngFor="let photo of photoPreviews" class="slide">
                  <img [src]="photo" alt="Selected Photo" />
                </div>
              </div>
              <div *ngIf="photoPreviews.length > 1">
                <button class="prev" (click)="prevSlide()">&#10094;</button>
                <button class="next" (click)="nextSlide()">&#10095;</button>
              </div>
            </div>
            <div *ngIf="isPost" class="create_post_bottom">
              <div class="create_post_like">
                <mat-icon class="material-symbols-outlined" style="margin-right: 5px; vertical-align: top;">
                  thumb_up
                </mat-icon>
                Like
              </div>
              <div class="create_post_like">
                <mat-icon class="material-symbols-outlined" style="margin-right: 5px; vertical-align: top;">
                  comment
                </mat-icon>
                Comment
              </div>
              <div class="create_post_like">
                <mat-icon class="material-symbols-outlined" style="margin-right: 5px; vertical-align: top;">
                  share
                </mat-icon>
                Share
              </div>
            </div>
          </div>
          <div *ngIf="isPreviewEmpty" class="no_preview">
            <img *ngIf="isPost" src="/assets/post_icon.png" alt="post" style="height: 100%; width: 100%;">
            <img *ngIf="isShortVideo" src="/assets/shorts_icon.png" alt="post" style="height: 100%; width: 100%;">
            <img *ngIf="isStory" src="/assets/stories_icon.png" alt="post" style="height: 100%; width: 100%;">
            <img *ngIf="isThread" src="/assets/threads_icon.png" alt="post" style="height: 100%; width: 100%;">
            <img *ngIf="isPoll" src="/assets/polls_icon.png" alt="post" style="height: 100%; width: 100%;">
          </div>
        </div>
        
      </div>
    </div>
  </div>